import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import Toolbar from './toolbar';
import Spacer from '../spacer';

import { useKeyDown } from '../../lib/hooks';

export const EditorContainer = styled.div`
    .wrs_editor {
        min-height: 72px;
        z-index: 0;
    }
`;

const WirisEditor = ({ content, onChange, onConfirm }) => {
    const ref = useRef();
    const [wirisEditor] = useState(() => {
        let editor = window.com.wiris.jsEditor.JsEditor.newInstance({
            language: 'it',
            toolbarHidden: true,
            fontSize: '16px',
            color: '#424548',
            display: 'inline-block',
            checkSyntax: true,
        });
        editor.setMathML(content);
        return editor;
    }, []);

    const enterKeyPress = useKeyDown('Enter');

    useEffect(() => {
        if (wirisEditor) {
            wirisEditor.insertInto(ref.current);
        }
    }, [wirisEditor]);

    /**
     * This effect is needed to clear or change the content of the
     * Wiris editor when the change is coming from a parent component.
     *
     * For ex. user presses delete button in the first step and default
     * math replaces the content.
     *
     * Note: content !== wirisEditor.getMathML() is required to avoid
     * unneeded rerenders and cursor misplacing.
     */
    useEffect(() => {
        if (wirisEditor && content !== wirisEditor.getMathML()) {
            wirisEditor.setMathML(content);
        }
    }, [wirisEditor, content]);

    return (
        <div>
            <EditorContainer
                ref={ref}
                onKeyUp={() => {
                    setTimeout(() => {
                        const wirisEditorContent = wirisEditor.getMathML().replace('<mspace linebreak="newline"/>', '');
                        if (enterKeyPress) {
                            onConfirm(wirisEditorContent);
                        } else {
                            onChange(wirisEditorContent);
                        }
                    }, 200);
                }}
            />
            <Toolbar editor={wirisEditor} onChange={onChange} />
            <Spacer size="small" />
        </div>
    );
};

WirisEditor.propTypes = {
    content: PropTypes.string,
    onChange: PropTypes.func,
    onConfirm: PropTypes.func,
};

export default WirisEditor;
